import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment'
import SelectForm from './../components/Complements/SelectForm';
//import Title from './../components/Complements/Title';
import DateFnsUtils from '@date-io/date-fns';
import "moment/locale/es";
import esLocale from "date-fns/locale/es";
import { connect } from 'react-redux';
import { getDepositsMovements } from "./../actions/deposits";
import Button from '@material-ui/core/Button';
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker,
} from '@material-ui/pickers';
import { Grid, CircularProgress, Icon, Fab } from '@material-ui/core';
// import MaterialTable from 'material-table';

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import Typography from '@material-ui/core/Typography';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import './../components/Codes/style/tableresponsive.css';
import Pagination from '@material-ui/lab/Pagination';
import Alert from '@material-ui/lab/Alert';
import Dashboard from '../components/Menu/Dashboard';
import { history } from '../helpers/history';
//import { isEmpty } from '../functions/arrays';
import Footer from '../components/Complements/Footer';
import { exportExcel } from './../functions/exportExcel'
import { sendMobile } from '../functions/mobile';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';

//const ExcelFile = ReactExport.ExcelFile;
//const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
//const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const DepositsContainer = props => {

    const { classes, getDepositsMovements, secuencial, parameters } = props
    const [depositspaginate, setDepositsPaginate] = useState([])
    const [deposits, setDeposits] = useState(props.deposits)
    const [page, setPage] = useState(1)
    const [count, setCount] = useState(1)
    // const [ secuencialAccount, setSecuencialAccount ] = useState(secuencial)
    const [loading, setLoading] = useState(false)
    const [dateStart, setDateStart] = useState(new Date())
    const [dateEnd, setDateEnd] = useState(new Date())
    const [dateValue, setDateValue] = useState(JSON.stringify({ month: moment().month(), year: moment().year() }))

    const mount = () => {
        const unmount = () => {
            try {
                // console.log(props.deposits)
                moment.locale('es-es')
                handleGetDeposits(dateStart, dateEnd, secuencial)
                /* let dateStartSend = (dateStart.getFullYear() -1) + "-" + (dateStart.getMonth() +1) + "-" + dateStart.getDate()
                if (isEmpty(props.deposits)) {
                    handleGetDeposits(dateStart, dateEnd, secuencial)
                } else if (props.deposits.info) {
                    if (props.deposits.info.length > 0  ) {
                        handleGetDeposits(dateStart, dateEnd, secuencial)
                    }
                } */
            } catch (error) {
                //console.log(error)
            }

        }
        return unmount()
    }
    useEffect(mount, [])
    // functions
    // SecuencialDeposito, FechaInicio, FechaFin, SecuencialEmpresa
    const handleGetDeposits = (FechaInicio, FechaFin, secuencial) => {
        getDepositsMovements(FechaInicio, FechaFin, secuencial).then(res => {
            // console.log(res)
            const newData = res.payload.data.movimientosDepositos.map(function (item) {
                return {
                    ...item,
                    fecha: (moment(item.fecha).format('YYYY-MM-DD'))
                }
            })
            // console.log(newData)
            //setDeposits(res.payload.data.movimientosDepositos)
            setDeposits(newData)
            setLoading(false)
            // setSecuencialAccount(match.params.id)
            filterDepositsByDate(FechaInicio, FechaFin, res.payload.data)
            getDataViewTableDeposits(newData)
        }).catch(error => {
            //console.log('no se a podido encontrar codes', error)
        })
    }
    // mayor
    const dateAfter = (str1, str2) => {
        return new Date(str1) >= new Date(str2);
    }
    // menor
    const dateBefore = (str1, str2) => {
        return new Date(str1) <= new Date(str2);
    }
    const filterDepositsByDate = (dateStart, dateEnd, dep) => {
        try {
            const dataResult = dep.filter((deposit) => {
                let dateFormat = moment(deposit.Fecha, 'DD/MM/YYYY').format('YYYY-MM-DD hh:mm:ss')
                if (dateAfter(dateFormat, dateStart) && dateBefore(dateFormat, dateEnd)) {
                    return true
                } else {
                    return false
                }
            })
            getDataViewTableDeposits(dataResult)
            setDeposits(dataResult)
        } catch (error) {
            //console.log('error filterDepositsByDate ', error)
        }

    }
    const getDataViewTableDeposits = (deposits) => {
        let dataDepositsPaginate = [];
        let count = parseInt((deposits.length / 5).toString());
        let residuo = deposits.length % 5;

        if (residuo > 0) {
            count++;
        }

        if (deposits.length > 0) {
            dataDepositsPaginate = deposits.slice(0, 5);
        }
        setDepositsPaginate(dataDepositsPaginate)
        setCount(count)
        setPage(1)
    }
    const handleDateStart = (date) => {
        setDateStart(date)
    }
    const handleDateEnd = (date) => {
        setDateEnd(date)
    }

    const onChangePaginationDeposits = (e, page) => {
        let init = (page - 1) * 5;
        let end = page * 5;
        let dataDepositsPaginate = [];
        dataDepositsPaginate = deposits.slice(init, end)
        setDepositsPaginate(dataDepositsPaginate)
        setPage(page)
    }

    const excel = async () => {
        // console.log(depositspaginate)
        let headers = ['Fecha',
            'Tipo',
            'Concepto',
            'Monto',
            'Saldo']
        let docName = "Movimientos de Depositos"
        let columnNames = ["fecha", "transaccion", "tipoDeposito", "valor", "saldo"]
        let docType = 2
        await exportExcel(headers, deposits, docName, columnNames, docType)
    }

    //render
    const renderTableMovements = () => {
        if (loading) {
            return <CircularProgress />
        } else {
            if (depositspaginate.length > 0) {
                return <div className={"container"}>
                    <Grid item xs={12} md={12} lg={12}>
                        {
                            (localStorage.caja_app !== undefined) ?

                                <Button style={{
                                    fontSize: '60%',
                                    color: '#FFFFFF',
                                    backgroundColor: "#2E2757",
                                    borderRadius: '4px',
                                    //fontFamily: 'Roboto-Medium',
                                    fontWeight: 'bold'
                                }} onClick={() => {
                                    let send = {
                                        type: 'action',
                                        action: 'export_movements_excel',
                                        data: `{"dateStart":"${moment(dateStart).format('YYYY-MM-DD')}","dateEnd": "${moment(dateEnd).format('YYYY-MM-DD')}", "secuencial":"${secuencial}"}`
                                    }
                                    sendMobile(JSON.stringify(send))
                                }} >EXPORTAR EN EXCEL</Button>
                                :
                                <Grid item xs={12} md={12} lg={12}>
                                    <Button size={"large"} variant="contained" style={{
                                        fontSize: '0.8rem',
                                        color: '#FFFFFF',
                                        backgroundColor: "#2E2757",
                                        borderRadius: '4px',
                                        //fontFamily: 'Roboto-Medium',
                                        fontWeight: 'bold'
                                    }} startIcon={<Icon>attach_file</Icon>}
                                        onClick={excel}
                                    >EXPORTAR EN EXCEL</Button>
                                </Grid>
                        }
                        {/* <ExcelFile element={<Button size={"large"} variant="contained" >Exportar a Excel</Button>} filename={"Movimientos de Depositos"}>
                            <ExcelSheet data={deposits} name="Movimientos">
                                <ExcelColumn label="Fecha" value={(col) => moment(col.fecha).format("YYYY-MM-DD")} />
                                <ExcelColumn label="Tipo" value="transaccion" />
                                <ExcelColumn label="Concepto" value="tipoDeposito" />
                                <ExcelColumn label="Valor" value="valor" />
                                <ExcelColumn label="Saldo" value="saldo" />
                            </ExcelSheet>

                        </ExcelFile> */}
                    </Grid>
                    <br />
                    <br />
                    <Grid item xs={12} md={12} lg={12}>
                        <Table className={"table"}>
                            <Thead>
                                <Tr>
                                    <Th>Fecha</Th>
                                    <Th>Tipo</Th>
                                    <Th>Concepto</Th>
                                    <Th>Monto</Th>
                                    <Th>Saldo</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {

                                    depositspaginate.map(row => (
                                        <Tr key={row.documento}>
                                            <Td>{row.fecha}</Td>
                                            <Td>{row.transaccion}</Td>
                                            <Td>{row.tipoDeposito}</Td>
                                            <Td>$ {row.valor}</Td>
                                            <Td>$ {row.saldo}</Td>
                                        </Tr>
                                    ))

                                }

                            </Tbody>
                        </Table>
                    </Grid>
                    <Pagination
                        style={{marginTop: '5px'}}
                        count={count}
                        //color="primary"
                        page={page}
                        onChange={onChangePaginationDeposits}
                    />
                </div>
            } else {
                return <Alert severity="info">No se han encontrado movimientos en el mes seleccionado.</Alert>
            }
        }
    }

    const handleSelectDeposit = (val) => {
        try {
            // console.log('HANDLESELECTDEPOSIT: ', props.deposits)
            setDateValue(val)
            setLoading(true)
            setDeposits(props.deposits.movements)
            if (val === 'Todos los movimientos') {
                setLoading(false)
                setDeposits(props.deposits.movements)
                getDataViewTableDeposits(props.deposits.movements);
            } else {
                let obj = JSON.parse(val)
                let selectMonth = new Date(obj.year, obj.month, 1)
                setDateStart(moment(selectMonth).startOf('month'))
                setDateEnd(moment(selectMonth).endOf('month'))
                let valueStart = moment(selectMonth).startOf('month');
                let valueEnd = moment(selectMonth).endOf('month');
                handleGetDeposits(valueStart, valueEnd, secuencial)
                setDateValue(val)
                /* if (deposits.length > 0) {
                    let selectMonth = new Date(obj.year, obj.month, 1)
                    let dateStart = moment(selectMonth).startOf('month').format('YYYY-MM-DD')
                    let dateEnd = moment(selectMonth).endOf('month').format('YYYY-MM-DD')
                    filterDepositsByDate(dateStart, dateEnd, props.deposits.movements)
                    setDateValue(val)
                    setLoading(false)
                } else {
                    getDataViewTableDeposits(props.deposits.movements)
                    setLoading(false)
                } */
            }
        } catch (error) {
            //console.log(error)
        }


    }
    const handleFindRange = () => {
        try {
            if (deposits.length > 0) {
                filterDepositsByDate(dateStart, dateEnd, props.deposits.movements)
            } else {
                handleGetDeposits(dateStart, dateEnd, secuencial)
            }
        } catch (error) {
            //console.log(error)
        }
    }

    const renderBody = () => {
        return <div style={{ padding: "20px", border: '2px solid #BEBCC0',  borderRadius: "8px", /* boxShadow: '4px 4px 4px 0px rgba(46,46,46,0.75)'*/ }}>
            <Grid container spacing={3}>
                <Grid item xs={12} md={8} lg={8} sm={12}>
                    <Typography component="h2" variant="h6" gutterBottom style={{
                        //fontFamily: "Roboto-Bold",
                        color: "#000000",
                        //padding: "3% 1% 1% 1%",
                        fontSize: "120%"
                    }}>
                        Detalle de Depósitos a plazo fijo
                    </Typography>
                </Grid>
                {/* <Grid item xs={12} md={4} lg={4} sm={12}>
                </Grid> */}
            </Grid>
            <SelectForm
                name={'Período'}
                label={'Seleccionar período '}
                // data = { [{ id: '1', name: 'data'}] }
                classes={classes}
                dateValue={dateValue}
                onSelected={(val) => handleSelectDeposit(val)}
                parameters={parameters}
            //onSubmit={ handleSubmit }
            ></SelectForm>
            {/* <SelectForm
                        name = { 'Período' }
                        label = { 'Seleccione período '}
                        // data = { [{ id: '1', name: 'data'}] }
                        classes = { classes }
                        dateValue = { dateValue }
                        onSelected = { (val) => handleSelectDeposit(val)}
                        onSubmit={ handleSubmit }
                    ></SelectForm> */}
            <br></br>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Grid container justify="center" spacing={3} alignItems="flex-end">
                        <Grid item md={4} sm={12} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                <KeyboardDatePicker
                                    autoOk
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    margin="normal"
                                    id="date-start"
                                    label="Fecha de inicio"
                                    value={dateStart}
                                    onChange={handleDateStart}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    keyboardIcon={<CalendarTodayIcon style={{ color: "#2E2757" }} />}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={4} sm={12} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                                <KeyboardDatePicker
                                    autoOk
                                    variant="inline"
                                    format="dd/MM/yyyy"
                                    margin="normal"
                                    id="date-end"
                                    label="Fecha de fin"
                                    value={dateEnd}
                                    onChange={handleDateEnd}
                                    KeyboardButtonProps={{
                                        'aria-label': 'change date',
                                    }}
                                    keyboardIcon={<CalendarTodayIcon style={{ color: "#2E2757" }} />}
                                />
                            </MuiPickersUtilsProvider>
                        </Grid>
                        <Grid item md={2} sm={6} xs={6} container direction="column" justifyContent='center' alignItems="center">
                            <Fab color="FFFFFF" style={{ backgroundColor: '#2E2757' }} aria-label="add" onClick={handleFindRange} >
                                <Icon style={{ color: "#FFFFFF" }}>search</Icon>
                            </Fab>
                            <Typography component="h2" variant="h6" gutterBottom style={{
                                //fontFamily: "MyriadPro-SemiBold",
                                color: "#000000",
                                fontSize: "120%"
                            }}>
                                CONSULTAR
                            </Typography>
                        </Grid>
                        <Grid item md={2} sm={6} xs={6} container direction="column" justifyContent='center' alignItems="center">
                            <Fab color="FFFFFF" style={{ backgroundColor: '#2E2757' }} aria-label="add" onClick={() => history.push('/')} >
                                <Icon style={{ color: "#FFFFFF" }}>close</Icon>
                            </Fab>
                            <Typography component="h2" variant="h6" gutterBottom style={{
                                //fontFamily: "MyriadPro-SemiBold",
                                color: "#000000",
                                fontSize: "120%"
                            }}>
                                CANCELAR
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <br /> <br />
            <Grid container justify="center" spacing={3} alignItems="center" m={10}>
                {
                    renderTableMovements()
                }
            </Grid>
        </div>
    }
    return (
        <div>
            <Dashboard
                title="Dashboard"
                body={renderBody()}
                multiple={false}
            />
            <Footer />
        </div>
    );
};



DepositsContainer.propTypes = {
    secuencial: PropTypes.string.isRequired,
}

export default connect(null, { getDepositsMovements })(DepositsContainer);
